export const vi = {
  dashboard: {
    greetingMorning: 'Chào buổi sáng',
    greetingAfternoon: 'Chào buổi chiều',
    greetingEvening: 'Chào buổi tối',
    subtitle: 'Đây là trang tổng quan của bạn trên LICO Portal.',
    modulesTitle: 'Module đang hoạt động',
    modulesHint: 'Các phân hệ bạn được phép truy cập',
    systemTitle: 'Hệ thống',
    version: 'Phiên bản',
    environment: 'Môi trường',
    quickActions: 'Truy cập nhanh',
    recentActivity: 'Hoạt động gần đây của bạn',
    recentActivityEmpty: 'Chưa có hoạt động',
    widgetError: 'Không hiển thị được mục này. Tải lại trang để thử lại.',
    allActivity: 'Xem toàn bộ nhật ký',
    notifications: 'Thông báo',
    loadError: 'Không tải được thông tin hệ thống',
  },
  settings: {
    title: 'Cài đặt',
    description: 'Thông tin công ty và cài đặt của từng phân hệ.',
    company: 'Thông tin công ty',
    companyHint: 'Hiện ở thanh bên và trang đăng nhập.',
    companyName: 'Tên hiển thị',
    companyNamePlaceholder: 'LICO Portal',
    logo: 'Logo',
    logoHint: 'PNG, JPG hoặc WebP, tối đa 512 KB; nên dùng ảnh vuông.',
    uploadLogo: 'Tải logo lên',
    removeLogo: 'Xoá logo',
    noLogo: 'Chưa có logo',
    save: 'Lưu',
    saved: 'Đã lưu cài đặt',
    reset: 'Về mặc định',
    defaultValue: 'Mặc định: {{value}}',
    on: 'Bật',
    off: 'Tắt',
    loadError: 'Không tải được cài đặt',
    retry: 'Thử lại',
    noModules: 'Chưa có phân hệ nào có cài đặt.',
  },
  modules: {
    title: 'Module',
    description: 'Các phân hệ đã đăng ký trong Portal, theo thứ tự phụ thuộc.',
    name: 'Tên',
    version: 'Phiên bản',
    kind: 'Loại',
    status: 'Trạng thái',
    dependencies: 'Phụ thuộc',
    permissions: 'Quyền',
    core: 'Lõi',
    business: 'Nghiệp vụ',
    enabled: 'Đang bật',
    disabled: 'Đã tắt',
    none: 'Không có',
    optional: 'tuỳ chọn',
    requiredBy: 'Được yêu cầu bởi',
    databaseSchema: 'Schema cơ sở dữ liệu',
    empty: 'Chưa có module nào',
    loadError: 'Không tải được danh sách module',
    retry: 'Thử lại',
    details: 'Chi tiết module',
    managementNote:
      'Module lõi luôn bật. Module nghiệp vụ có thể tắt cho toàn công ty: menu và chức năng của nó bị ẩn, dữ liệu được giữ nguyên.',
    alwaysOn: 'Luôn bật',
    toggled: 'Đã cập nhật module',
  },
};

export const en: typeof vi = {
  dashboard: {
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    subtitle: 'This is your overview of LICO Portal.',
    modulesTitle: 'Active modules',
    modulesHint: 'Modules you can access',
    systemTitle: 'System',
    version: 'Version',
    environment: 'Environment',
    quickActions: 'Quick access',
    recentActivity: 'Your recent activity',
    recentActivityEmpty: 'No activity yet',
    widgetError: 'This card could not be shown. Reload the page to try again.',
    allActivity: 'Full activity log',
    notifications: 'Notifications',
    loadError: 'Could not load system information',
  },
  settings: {
    title: 'Settings',
    description: 'Company details and the settings of each module.',
    company: 'Company',
    companyHint: 'Shown in the sidebar and on the sign-in page.',
    companyName: 'Display name',
    companyNamePlaceholder: 'LICO Portal',
    logo: 'Logo',
    logoHint: 'PNG, JPG or WebP, up to 512 KB; a square image works best.',
    uploadLogo: 'Upload logo',
    removeLogo: 'Remove logo',
    noLogo: 'No logo yet',
    save: 'Save',
    saved: 'Settings saved',
    reset: 'Reset to default',
    defaultValue: 'Default: {{value}}',
    on: 'On',
    off: 'Off',
    loadError: 'Could not load settings',
    retry: 'Retry',
    noModules: 'No module has settings yet.',
  },
  modules: {
    title: 'Modules',
    description: 'Modules registered in the Portal, in dependency order.',
    name: 'Name',
    version: 'Version',
    kind: 'Kind',
    status: 'Status',
    dependencies: 'Dependencies',
    permissions: 'Permissions',
    core: 'Core',
    business: 'Business',
    enabled: 'Enabled',
    disabled: 'Disabled',
    none: 'None',
    optional: 'optional',
    requiredBy: 'Required by',
    databaseSchema: 'Database schema',
    empty: 'No modules yet',
    loadError: 'Could not load modules',
    retry: 'Retry',
    details: 'Module details',
    managementNote:
      'Core modules are always on. Business modules can be switched off company-wide: their menu and features are hidden, data is kept.',
    alwaysOn: 'Always on',
    toggled: 'Module updated',
  },
};
